/* eslint-disable no-loop-func */
export type Breakup = {
  totalPaid: number;
  interest: number;
  principal: number;
};

export interface MonthBreakup extends Breakup {
  month: number;
}

export interface YearBreakup extends Breakup {
  year: number;
  breakup: MonthBreakup[];
}

export type ResultData = {
  loanAmt: number;
  totalPaid: number;
  monthlyAmt: number;
  interest: number;
  months: number;
  breakup: YearBreakup[];
};

function formatBreakup(breakup: any[]) {
  const yearArr: YearBreakup[] = [];

  const currYear = new Date().getFullYear();
  let currMonth = new Date().getMonth();

  let year: number;
  let month: number;

  year = currYear;
  if (currMonth === 11) {
    year += 1;
    currMonth = -1;
  }
  month = currMonth + 1;

  let iter = 0;
  const len = breakup.length;
  for (iter; iter < len; iter += 1) {
    const item: any = breakup[iter];

    const findYearIndex = yearArr.findIndex((el: any) => el.year === year);

    if (findYearIndex !== -1) {
      yearArr[findYearIndex].breakup.push({
        interest: item.interest,
        totalPaid: item.totalPaid,
        month,
        principal: item.principal,
      });
      yearArr[findYearIndex].totalPaid += item.totalPaid;
      yearArr[findYearIndex].principal += item.principal;
      yearArr[findYearIndex].interest += item.interest;
    } else {
      yearArr.push({
        year,
        totalPaid: item.totalPaid,
        principal: item.principal,
        interest: item.interest,
        breakup: [
          {
            interest: item.interest,
            totalPaid: item.totalPaid,
            principal: item.principal,
            month,
          },
        ],
      });
    }

    if (month === 11) {
      year += 1;
      month = 0;
    } else {
      month += 1;
    }
  }

  return yearArr;
}

export function calculateEMI({
  loanAmt,
  interest,
  tenure,
}: {
  loanAmt: number;
  interest: number;
  tenure: number;
}) {
  let balance = +loanAmt;

  const result: ResultData = {
    loanAmt,
    totalPaid: null,
    monthlyAmt: null,
    interest: null,
    months: null,
    breakup: [],
  };

  const updatedTenure = tenure * 12;

  const interestRate = parseFloat(String(interest / 100.0));

  const monthlyRate = interestRate / 12;

  // eslint-disable-next-line no-restricted-properties
  const payment =
    balance * (monthlyRate / (1 - (1 + monthlyRate) ** -updatedTenure));

  result.totalPaid = Number(Math.round(payment * updatedTenure));
  result.monthlyAmt = Number(Math.round(payment));
  result.interest = Number((interestRate * 100).toFixed(2));
  result.months = updatedTenure;

  const breakups = [];

  for (let count = 0; count < updatedTenure; count += 1) {
    let interest = 0;
    let monthlyPrincipal = 0;
    interest = balance * monthlyRate;
    monthlyPrincipal = payment - interest;

    breakups.push({
      month: count + 1,
      balance: Number(Math.round(balance)),
      interest: Number(Math.round(interest)),
      principal: Number(Math.round(monthlyPrincipal)),
      totalPaid: Math.round(payment),
    });

    // update the balance for each loop iteration
    balance -= monthlyPrincipal;
  }

  result.breakup = formatBreakup(breakups);
  return result;
}
